export class PageFilter {
    currentPage?: number;
    pageSize?: number;
}